<cm-ui-dialog
  [title]="'ADMIN.medialibrary.aiLabels.dialog.title' | translate"
  [closeLabel]="'common.close' | translate">
  @if (loading()) {
    <cm-ui-loader />
  } @else if (!current()) {
    <p class="empty">{{ 'ADMIN.medialibrary.aiLabels.dialog.noSuggestions' | translate }}</p>
  } @else {
    @if (total() > 1) {
      <div class="asset-counter">{{ 'ADMIN.medialibrary.aiLabels.dialog.assetOf' | translate: { index: index() + 1, total: total() } }}</div>
    }
    <div class="asset-header">
      @if (currentAsset()?.thumbnailUrl) {
        <img class="asset-thumb" [src]="currentAsset()!.thumbnailUrl" alt="" />
      }
      <div class="asset-text">
        <div class="asset-name">{{ currentAsset()?.name || current()!.mediaassetUuid }}</div>
        @if (current()!.summary) {
          <div class="asset-summary">{{ current()!.summary }}</div>
        }
      </div>
    </div>

    @switch (current()!.status) {
      @case ('PENDING') {
        <p class="state-note"><mat-icon>hourglass_top</mat-icon> {{ 'ADMIN.medialibrary.aiLabels.dialog.pending' | translate }}</p>
      }
      @case ('FAILED') {
        <p class="state-note state-note--error"><mat-icon>error_outline</mat-icon> {{ 'ADMIN.medialibrary.aiLabels.dialog.failed' | translate }} <span class="error-detail">{{ current()!.error }}</span></p>
      }
      @default {
        @if (current()!.resolution) {
          <p class="state-note"><mat-icon>check_circle</mat-icon> {{ 'ADMIN.medialibrary.aiLabels.dialog.resolved' | translate: { resolution: current()!.resolution } }}</p>
        }
        @if (groups().length === 0) {
          <p class="empty">{{ 'ADMIN.medialibrary.aiLabels.dialog.noSuggestions' | translate }}</p>
        }
        @for (group of groups(); track group.definitionUuid) {
          <section class="group">
            <div class="group-header">
              <cm-ui-standard-button
                [icon]="isExpanded(group) ? 'expand_more' : 'chevron_right'"
                [alt]="group.definitionName"
                (onClick)="toggleGroup(group)" />
              <span class="group-name">{{ group.definitionName }}</span>
              <span class="group-counts">
                {{ group.existing.length }} {{ 'ADMIN.medialibrary.aiLabels.dialog.existing' | translate | lowercase }}
                · {{ group.proposed.length }} {{ 'ADMIN.medialibrary.aiLabels.dialog.proposed' | translate | lowercase }}
              </span>
            </div>

            @if (isExpanded(group)) {
              @if (group.existing.length) {
                <div class="subheading">{{ 'ADMIN.medialibrary.aiLabels.dialog.existing' | translate }}</div>
                <ul class="rows">
                  @for (match of group.existing; track match.labelUuid) {
                    <li class="row" [class.row--applied]="match.applied" [class.row--rejected]="match.rejected">
                      <mat-checkbox
                        [checked]="match.applied || isExistingSelected(match)"
                        [disabled]="match.applied || match.rejected || !isActionable()"
                        (change)="toggleExisting(match)" />
                      <app-label-chip [label]="chipFor(match, group)" />
                      <span class="confidence" [matTooltip]="match.rationale || ''">{{ percent(match.confidence) }}</span>
                      @if (match.applied) {
                        <span class="applied-tag"><mat-icon>check</mat-icon>{{ 'ADMIN.medialibrary.aiLabels.dialog.appliedTag' | translate }}</span>
                      } @else if (match.rejected) {
                        <span class="rejected-tag">{{ 'ADMIN.medialibrary.aiLabels.dialog.rejectedTag' | translate }}</span>
                      }
                    </li>
                  }
                </ul>
              }
              @if (group.proposed.length) {
                <div class="subheading">{{ 'ADMIN.medialibrary.aiLabels.dialog.proposed' | translate }}</div>
                <ul class="rows">
                  @for (proposal of group.proposed; track proposal.name) {
                    <li class="row" [class.row--applied]="proposal.accepted" [class.row--rejected]="proposal.rejected">
                      <mat-checkbox
                        [checked]="proposal.accepted || isProposalSelected(group, proposal)"
                        [disabled]="proposal.accepted || proposal.rejected || !isActionable()"
                        (change)="toggleProposal(group, proposal)" />
                      <span class="proposal-chip">
                        <span class="new-tag">{{ 'ADMIN.medialibrary.aiLabels.dialog.newTag' | translate }}</span>
                        {{ proposal.name }}
                      </span>
                      <span class="confidence" [matTooltip]="proposal.rationale || ''">{{ percent(proposal.confidence) }}</span>
                      @if (proposal.accepted) {
                        <span class="applied-tag"><mat-icon>check</mat-icon>{{ 'ADMIN.medialibrary.aiLabels.dialog.appliedTag' | translate }}</span>
                      } @else if (proposal.rejected) {
                        <span class="rejected-tag">{{ 'ADMIN.medialibrary.aiLabels.dialog.rejectedTag' | translate }}</span>
                      }
                    </li>
                  }
                </ul>
              }
            }
          </section>
        }
      }
    }
  }


  <ng-container footer-left>
    <cm-ui-standard-button rounded icon="chevron_left" [disabled]="index() === 0 || saving()" (onClick)="previous()">
      {{ 'ADMIN.medialibrary.aiLabels.dialog.previous' | translate }}
    </cm-ui-standard-button>
    <cm-ui-standard-button rounded icon="chevron_right" [disabled]="index() >= total() - 1 || saving()" (onClick)="next()">
      {{ 'ADMIN.medialibrary.aiLabels.dialog.next' | translate }}
    </cm-ui-standard-button>
  </ng-container>
  <ng-container footer-right>
    <cm-ui-standard-button rounded [disabled]="saving()" (onClick)="close()">
      {{ 'ADMIN.medialibrary.aiLabels.dialog.later' | translate }}
    </cm-ui-standard-button>
    @if (isActionable()) {
      @if (hasPendingProposals()) {
        <cm-ui-standard-button rounded icon="block" [disabled]="saving()" (onClick)="rejectAll()">
          {{ 'ADMIN.medialibrary.aiLabels.dialog.rejectAll' | translate }}
        </cm-ui-standard-button>
      }
      <cm-ui-standard-button rounded green icon="check" [disabled]="saving() || (selectionCount() === 0 && !hasPendingProposals())" (onClick)="applyAndRejectRest()">
        {{ 'ADMIN.medialibrary.aiLabels.dialog.applySelected' | translate }}
      </cm-ui-standard-button>
    }
  </ng-container>
</cm-ui-dialog>
